import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppRoutingModule } from './/app-routing.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';

import { SharedModule } from './_shared/shared.module';

import { IndicatorService } from './_services/indicator.service';
import { GoogleAnalyticsService } from './_services/google-analytics.service';
import { MetatagsService } from './_services/metatags.service';
import { StatusService } from './_services/status.service';
import { httpCacheInterceptor, httpRetryInterceptor } from './_interceptors/http-cache.interceptor';

// Only the shell and the landing route live here now. Every other section is a lazy
// route (see app-routing.module.ts), and the components they share come from
// SharedModule, which also re-exports the third-party modules templates rely on.
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule,
    SharedModule,
    AppRoutingModule,
  ],
  providers: [
    // Retry sits outside the cache so a retried request still populates it, and a
    // cache hit never goes near the retry logic.
    provideHttpClient(withInterceptors([httpCacheInterceptor, httpRetryInterceptor])),
    IndicatorService,
    GoogleAnalyticsService,
    MetatagsService,
    StatusService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
